<template>
    <div class="data-evaluation-page">
        <!-- 企业信息 -->
        <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
                <span>企业信息</span>
                <el-button type="text" style="color: #67C23A; float: right; padding: 0;" @click="viewCompanyDetail">
                    查看详情
                </el-button>
            </div>
            <el-table :data="enterpriseInfoData" style="width: 100%" :show-header="false" border>
                <el-table-column prop="label" width="200"></el-table-column>
                <el-table-column>
                    <template slot-scope="scope">
                        {{ scope.row.value }}
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 数据资产信息 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据资产信息</span>
                <el-button type="text" style="color: #67C23A; float: right; padding: 0;" @click="viewReviewManage">
                    查看详情
                </el-button>
            </div>
            <el-table :data="dataAssetInfoData" style="width: 100%" :show-header="false" border>
                <el-table-column prop="label" width="200"></el-table-column>
                <el-table-column>
                    <template slot-scope="scope">
                        {{ scope.row.value }}
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 企业合规信息 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>企业合规信息</span>
            </div>
            <el-table :data="companyComplianceData" style="width: 100%" :show-header="false" border>
                <el-table-column prop="label" width="200"></el-table-column>
                <el-table-column>

                    <template slot-scope="scope">
                        <div v-for="(item, index) in getFileList(scope.row.value)" :key="index" class="file-item">
                            {{ item }}

                            <el-button v-if="isPreviewable(item)" type="text" size="mini" @click="previewFile(item)"
                                style="margin-left: 8px;">
                                预览
                            </el-button>
                            <el-button type="text" size="small" @click="downloadFile(scope.row.value, index)">
                                下载
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 数据合规信息 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据合规信息</span>
            </div>
            <el-table :data="dataComplianceData" style="width: 100%" :show-header="false" border>
                <el-table-column prop="label" width="200"></el-table-column>
                <el-table-column>
                    <template slot-scope="scope">
                        <div v-for="(item, index) in getFileList(scope.row.value)" :key="index" class="file-item">
                            {{ item }}

                            <span v-if="item">
                                <el-button v-if="isPreviewable(item)" type="text" size="mini" @click="previewFile(item)"
                                    style="margin-left: 8px;">
                                    预览
                                </el-button>
                                <el-button type="text" size="small" @click="downloadFile(scope.row.value, index)">
                                    下载
                                </el-button>
                            </span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 合规审核项目 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>合规审核项</span>
            </div>

            <el-form :model="formModel" label-position="left">
                <el-row :gutter="10">
                    <el-col :span="4">
                        <div v-for="(item, index) in complianceItems" :key="index" style="margin-bottom: 15px;">
                            <el-form-item :label="item.label + '：'" style="margin-bottom: 5px;">
                            </el-form-item>
                        </div>
                    </el-col>

                    <el-col :span="4">
                        <div v-for="(item, index) in complianceItems" :key="index" style="margin-bottom: 15px;">
                            <el-form-item style="margin-bottom: 5px;">
                                <el-radio-group v-model="item.result">
                                    <el-radio label="1" style="margin-right: 10px;">是</el-radio>
                                    <el-radio label="0">否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div v-for="(item, index) in complianceItems" :key="index"
                            style="margin-bottom: 15px; text-align: center;">
                            <el-form-item label="" style="margin-bottom: 5px;">
                                <el-button size="mini" type="primary" style="width: 120px;" @click="check(item)"
                                    :loading="getLoadingState(item.type)" :disabled="getButtonDisabled(item)">
                                    {{ getButtonText(item) }}
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-col>

                    <el-col :span="3">
                        <div v-for="(taskKey, index) in Object.keys(aiTasks)" :key="index"
                            style="margin-bottom: 15px; text-align: center;">
                            <el-form-item label="" style="margin-bottom: 5px;">
                                <span v-if="showUndeterminedPrompt(taskKey)" class="undetermined-prompt">
                                    无法判断，请人工核验！
                                </span>
                                <span v-else class="undetermined-prompt">
                                    &nbsp;
                                </span>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>

        <!-- 合规报告 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>企业主体合规</span>
            </div>
            <el-row :gutter="20">
                <el-col :span="8">
                    <div style="margin-bottom: 15px; text-align: center; ">
                        <el-button size="mini" type="primary" style="width: 100px;" @click="systmReport">
                            系统生成报告
                        </el-button>
                    </div>
                    <div style="margin-bottom: 15px; text-align: center;">
                        <el-button size="mini" type="primary" style="width: 100px;" @click="aiReport">
                            AI生成报告
                        </el-button>

                    </div>


                    <!-- 文件名展示区域 -->
                    <div v-if="sysReportName" class="report-name-container">
                        <div class="file-item" style="margin-top: 15px; ">
                            {{ sysReportName }}
                            <span>
                                <el-button v-if="isPreviewable(sysReportName)" type="text" size="mini"
                                    @click="previewFile(sysReportName)" style="margin-left: 8px;">
                                    预览
                                </el-button>
                                <el-button type="text" size="small" @click="downloadFile(sysReportName, null)">
                                    下载
                                </el-button>
                            </span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <!-- 上传区域 -->
                    <el-upload ref="upload" drag action='#' :auto-upload="false" :limit="10"
                        :on-change="handleReportFileChange" :on-remove="handleReportFileRemove" :file-list="reportFile"
                        :multiple="true">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">点击或拖拽文件到此处<br>
                            <span style="color: gray; font-size: 10px;">
                                支持 word 格式 文件大小不得超过{{ fileSizeLimit }}M</span>
                        </div>
                    </el-upload>

                </el-col>
            </el-row>
        </el-card>

        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>审核意见</span>
            </div>
            <el-row>
                <el-col :span="24">
                    <el-input type="textarea" v-model="platformReviewComments" placeholder="请输入内容"
                        style="width: 100%;"></el-input>
                </el-col>
            </el-row>
        </el-card>

        <div style="margin-top: 30px;  display: flex; justify-content: space-evenly;">
            <el-button type="warning" size="medium" @click="close('/DataComplianceManager')" style="width: 120px;">
                关闭
            </el-button>
            <el-button type="danger" size="medium" @click="handleReject" style="width:120px;">
                驳回
            </el-button>
            <el-button type="success" size="medium" :disabled="isSubmitDisabled" @click="handlePass"
                style="width: 120px;">
                通过
            </el-button>
        </div>
        <!-- 文件预览组件 -->
        <file-preview ref="filePreview" download-base-url="/web/dataComplianceDetail/download" />
    </div>
</template>
<script>
import FilePreview from '@/components/FilePreview.vue';

export default {
    name: 'DataComplianceManager',
    components: {
        FilePreview
    },
    data() {
        return {
            adminInfo: '',
            userId: '',
            companyId: '',
            companyName: '',
            isSelfStorage: '11',
            dataComplianceInfoData: null,
            registrationId: '',
            platformReviewComments: '', // 平台审核意见
            reportFile: [],  // 报告文件
            fileSizeLimit: 100, // 文件大小限制单位MB
            enterpriseInfoData: [],
            dataAssetInfoData: [],
            companyComplianceData: [],
            dataComplianceData: [],
            external_storage: false,
            aiBackBaseUrl: process.env.VUE_APP_AI_BACKEND_BASE_URL,
            fileBaseUrl: process.env.VUE_APP_AI_FILE_BASE_URL,
            AssetNameForAI: '',

            formModel: {
                complianceItems: []
            },
            complianceItems: [
                {
                    label: '材料是否齐全',
                    value: '',
                    status: '未检测', // 状态：未检测、检测中、检测完毕
                    result: '',
                    type: 'material',
                    buttonMsg: '检测',
                    taskId: '' // 存储任务ID
                },
                {
                    label: '企业主体是否合规',
                    value: '',
                    status: '未检测',
                    result: '',
                    type: 'enterprise',
                    buttonMsg: '检测',
                    taskId: ''
                },
                {
                    label: '数据来源是否合规',
                    value: '',
                    status: '未提交', // 状态：未提交、评估中、评估完毕
                    result: '',
                    type: 'source',
                    buttonMsg: '提交评估',
                    taskId: ''
                },
                {
                    label: '数据存储是否完善',
                    value: '',
                    status: '未提交',
                    result: '',
                    type: 'storage',
                    buttonMsg: '提交评估',
                    taskId: ''
                },
                {
                    label: '数据是否脱敏存储',
                    value: '',
                    status: '未提交',
                    result: '',
                    type: 'desensitization',
                    buttonMsg: '提交评估',
                    taskId: ''
                }
            ],
            sysReportName: '',

            aiTasks: {
                materialId: '',
                enterpriseTaskID: '',
                sourceTaskID: '',
                storageTaskID: '',
                desensitizationTaskID: '',
            },
            loadingStates: {
                material: false,
                enterprise: false,
                source: false,
                storage: false,
                desensitization: false
            },
            // 添加AI评估结果状态
            aiTaskResults: {
                materialId: '',
                enterpriseTaskID: '',
                sourceTaskID: '',
                storageTaskID: '',
                desensitizationTaskID: '',
            },

        }
    },
    created() {
        // 从路由中获取传递的参数
        this.registrationId = this.$route.query.registrationId || '';
        this.adminInfo = JSON.parse(window.localStorage.getItem('user'));

        if (this.registrationId) {
            this.initializeApplication();
        }
    },
    methods: {
        initializeApplication() {
            // 获取数据质量详情数据
            this.getRequest(`/web/dataComplianceDetail/query?registrationId=${this.registrationId}`)
                .then(resp => {
                    if (resp.data && resp.data.object) {
                        this.dataComplianceInfoData = resp.data.object;
                        console.log("获取数据质量详情数据");
                        console.log(resp.data);
                        // 企业合规信息
                        this.companyComplianceData = [
                            { label: '资质证明材料', value: this.dataComplianceInfoData.qualificationMaterials },
                        ];

                        // 数据合规信息
                        this.dataComplianceData = [
                            { label: '数据来源', value: this.dataComplianceInfoData.dataSourceMaterials },
                            { label: '数据脱敏处理', value: this.dataComplianceInfoData.dataSampleMaterials },
                            { label: '数据存储安全', value: this.dataComplianceInfoData.dataStorageMaterials }
                        ];

                        this.isSelfStorage = this.dataComplianceInfoData.isSelfStorage;
                    }
                })
                .catch(error => {
                    console.error('获取数据失败:', error);
                });
            // 获取企业信息
            this.getRequest(`/web/companyInfo/queryByRegistrationId?registrationId=${this.registrationId}`)
                .then(resp => {
                    if (resp.data) {
                        // console.log("获取企业信息:");
                        // console.log(resp.data);

                        this.enterpriseInfoData = [
                            { label: '企业名称', value: resp.data.companyName },
                            { label: '统一社会信用代码', value: resp.data.socialCreditCode },
                            { label: '经营范围', value: resp.data.businessNature },
                            { label: '联系人姓名', value: resp.data.contactsName },
                            { label: '联系电话', value: resp.data.contactsPhone }
                        ];
                        this.userId = resp.data.userId;
                        this.companyName = resp.data.companyName;
                        this.companyId = resp.data.companyId;

                    }
                })
                .catch(error => {
                    console.error('获取数据失败:', error);
                });
            // 查询数据资产信息
            this.getRequest(`/web/dataAssets/queryByRegistrationId?registrationId=${this.registrationId}`)
                .then(resp => {
                    if (resp.data) {
                        // console.log("查询数据资产信息:");
                        // console.log(resp.data);
                        this.AssetNameForAI = resp.data.assetName;
                        // 数据资产信息
                        this.dataAssetInfoData = [
                            { label: '数据资产名称', value: resp.data.assetName },
                            { label: '数据来源', value: resp.data.dataSource },
                            { label: '所属行业', value: resp.data.industry },
                            { label: '更新周期', value: resp.data.updateCycle },
                            { label: '数据覆盖地域', value: resp.data.region },
                            { label: '应用场景描述', value: resp.data.scenario },
                            { label: '数据资产简介', value: resp.data.description }
                        ];

                    }
                })
                .catch(error => {
                    console.error('获取数据失败:', error);
                });
        },

        // 文件下载
        async downloadFile(filename, index) {
            console.log("下载filename------------------");
            console.log(filename);
            console.log(index);
            // let fin
            // if(index == 0 || index =='' || index == null){
            //     console.log(1);
            // }
            // console.log(this.registrationId);
            let downloadFileName = '';
            if (index == '' || index == null) {
                downloadFileName = filename;
                console.log("文件下载：", downloadFileName);
            } else {
                downloadFileName = filename[index];
                console.log("文件下载：", downloadFileName);

            }

            try {
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/dataComplianceDetail/download?registrationId=' + this.registrationId + '&fileName=' + downloadFileName,
                    responseType: 'blob'
                });

                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', downloadFileName);
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('下载失败:', error);
                this.$message.error('文件下载失败: ' + error.message);
            }
        },

        handleReportFileRemove(file, fileList) { },
        // 提交报告
        handleReportFileChange(file, fileList) {
            // 校验文件类型
            const isWord = file.name.endsWith('.doc') || file.name.endsWith('.docx');
            if (!isWord) {
                this.$message.error('仅支持 word 文件格式！');
                // 从fileList中移除不符合条件的文件
                const index = fileList.indexOf(file);
                if (index > -1) {
                    fileList.splice(index, 1);
                }
                return;
            }

            // 校验文件大小
            const isLtLimit = file.size / 1024 / 1024 < this.fileSizeLimit;
            if (!isLtLimit) {
                this.$message.error(`上传文件大小不能超过 ${this.fileSizeLimit}MB！`);
                // 从fileList中移除不符合条件的文件
                const index = fileList.indexOf(file);
                if (index > -1) {
                    fileList.splice(index, 1);
                }
                return;
            }
            this.reportFile = fileList;
        },


        // 驳回
        async handleReject() {
            // console.log("驳回", this.adminInfo);
            if (this.platformReviewComments == "") {
                this.$message.error("请输入审核意见!");
                return;
            }
            try {
                const submitData = {
                    registrationId: this.registrationId,
                    platformReviewerId: '',  // 平台审核人id
                    platformReviewComments: this.platformReviewComments,  // 平台审核意见 
                    lawyerId: '',  // 律师id
                    lawyerReviewComments: '',  // 律师审核意见
                    result: 'reject'  // 审核结果   approve  通过,  reject  驳回
                };
                // console.log(submitData);
                // 调用表单提交接口
                const response = await this.$axios.post('/web/dataComplianceDetail/review', submitData, {
                    headers: {
                        'X-User-Id': this.adminInfo.id
                    }
                });

                if (response.data && response.data.status === 200) {
                    // 提交成功后显示确认弹窗
                    this.$confirm('驳回成功！', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        showCancelButton: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        this.close('/DataComplianceManager');
                    });
                } else {
                    this.$message.error('提交失败: ' + (response.data.msg || '未知错误'));
                }
            } catch (error) {
                console.error('提交失败:', error);
                this.$message.error('提交失败: ' + error.message);
            }
        },

        // 通过
        async handlePass() {
            // console.log("通过", this.adminInfo);

            // console.log(this.uploadSingleFile(this.reportFile, 'platformComplianceReport'));

            try {
                // 上传所有报告文件

                let platformComplianceReportUrl = '';

                // 只上传第一个报告文件
                if (this.reportFile.length > 0) {
                    const file = this.reportFile[0];
                    const response = await this.uploadSingleFile(file, 'platformComplianceReport');
                    if (response.data && response.data.status === 200 && response.data.object) {
                        platformComplianceReportUrl = response.data.object;
                    } else {
                        throw new Error(`文件 ${file.name} 上传失败: ${response.data.msg || '未知错误'}`);
                    }
                }
                const submitData = {
                    registrationId: this.registrationId,
                    materialsComplete: this.complianceItems[0].result,  // 材料是否齐全 0-不完整 1-完整
                    subjectCompliance: this.complianceItems[1].result,  // 主体是否合规 0-不合规 1-合规
                    sourceCompliance: this.complianceItems[2].result,   // 数据来源是否合规 0-不合规 1-合规
                    desensitizationCompliance: this.complianceItems[4].result,  // 数据去敏是否合规 0-不合规 1-合规
                    storageCompliance: this.complianceItems[3].result,   // 数据存储是否合规 0-不合规 1-合规
                    platformReviewerId: '',  // 平台审核人id
                    platformReviewComments: this.platformReviewComments,  // 平台审核意见 
                    platformComplianceReport: platformComplianceReportUrl,  // 平台合规报告
                    lawyerId: '',  // 律师id
                    lawyerReviewComments: '',  // 律师审核意见
                    lawyerComplianceReport: '',  // 律师合规报告
                    result: 'approve'  // 审核结果   approve  通过,  reject  驳回
                };
                // console.log(submitData);
                // 调用表单提交接口
                const response = await this.$axios.post('/web/dataComplianceDetail/review', submitData, {
                    headers: {
                        'X-User-Id': this.adminInfo.id
                    }
                });


                if (response.data && response.data.status === 200) {
                    // 提交成功后显示确认弹窗
                    this.$confirm('审核成功！', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        showCancelButton: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        this.close('/DataComplianceManager');
                    });
                } else {
                    this.$message.error('提交失败: ' + (response.data.msg || '未知错误'));
                }
            } catch (error) {
                console.error('提交失败:', error);
                this.$message.error('提交失败: ' + error.message);
            }


        },

        // 单个文件上传方法
        uploadSingleFile(file, fileType) {
            const formData = new FormData();
            formData.append('file', file.raw || file);
            formData.append('registrationId', this.registrationId);
            formData.append('type', fileType);

            return this.$axios.post('/web/dataComplianceDetail/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                // 在响应中添加文件类型信息
                if (response.data && response.data.status === 200 && response.data.object) {
                    response.data.fileType = fileType; // 添加文件类型标识
                }
                return response;
            });
        },

        // 刷新评估结果
        refreshResult() {
            this.$message.success('评估结果已刷新！');
        },
        // 修改：获取按钮文本
        getButtonText(item) {
            if (this.getLoadingState(item.type)) {
                return item.type === 'material' || item.type === 'enterprise' ? '检测中' : '评估中';
            }

            // 根据状态显示不同的按钮文本
            if (item.type === 'material' || item.type === 'enterprise') {
                // 材料和企业主体检测
                if (item.status === '检测完毕') {
                    return '检测完毕';
                }
                return item.buttonMsg;
            } else {
                // 数据来源、存储、脱敏评估
                if (item.status === '评估完毕') {
                    return '查看详情';
                }
                return item.buttonMsg;
            }
        },

        // 新增：判断按钮是否禁用
        getButtonDisabled(item) {
            // 如果是材料检测或企业主体检测，检测完毕后禁用
            if ((item.type === 'material' || item.type === 'enterprise') && item.status === '检测完毕') {
                return true;
            }

            // 数据来源、存储、脱敏评估完毕后不禁用，可以查看详情
            if (['source', 'storage', 'desensitization'].includes(item.type) && item.status === '评估完毕') {
                return false;
            }

            // 其他情况根据加载状态判断
            return this.getLoadingState(item.type);
        },



        getTaskButtonLabel(taskKey) {
            const labelMap = {
                'materialId': '材料检测',
                'enterpriseTaskID': '企业主体',
                'sourceTaskID': '数据来源',
                'storageTaskID': '数据存储',
                'desensitizationTaskID': '数据脱敏'
            };
            return labelMap[taskKey] || '查看详情';
        },



        getLoadingState(type) {
            return this.loadingStates[type] || false;
        },

        setLoadingState(type, isLoading) {
            this.$set(this.loadingStates, type, isLoading);
        },

        // 修改：检查按钮点击方法
        async check(item) {
            // 如果已经是评估完毕状态，且是数据来源、存储、脱敏评估，则跳转到详情页
            if (item.status === '评估完毕' && ['source', 'storage', 'desensitization'].includes(item.type)) {
                this.toDetail(item);
                return;
            }

            // 设置加载状态
            this.setLoadingState(item.type, true);

            try {
                switch (item.type) {
                    case 'material':  // 材料是否齐全
                        await this.handleMaterial();
                        break;
                    case 'enterprise':  // 企业主体是否合规
                        await this.handleEnterprise();
                        break;
                    case 'source':  // 数据来源
                        await this.handleSource1();
                        break;
                    case 'storage':  // 数据存储
                        await this.handleStorage1();
                        break;
                    case 'desensitization':  // 数据去敏
                        await this.handleDesensitization1();
                        break;
                    default:
                        break;
                }
            } catch (error) {
                console.error('提交评估失败:', error);
                this.$message.error('提交评估失败: ' + error.message);
            } finally {
                // 对于非轮询的方法，在这里清除加载状态
                if (!['source', 'storage', 'desensitization'].includes(item.type)) {
                    this.setLoadingState(item.type, false);
                }
            }
        },

        // 新增：模拟检测延迟的方法
        async simulateDetectionDelay(minSeconds = 3, maxSeconds = 5) {
            const delaySeconds = Math.floor(Math.random() * (maxSeconds - minSeconds + 1)) + minSeconds;
            return new Promise(resolve => {
                setTimeout(resolve, delaySeconds * 1000);
            });
        },


        // 修改：材料是否齐全检测
        async handleMaterial() {
            try {
                console.log('开始材料是否齐全检测...');

                // 设置状态为检测中
                const materialItem = this.complianceItems[0];
                materialItem.status = '检测中';

                // 添加3-5秒的检测延迟
                await this.simulateDetectionDelay(3, 5);

                // 检查企业合规信息中的资质证明材料是否存在
                const qualificationMaterials = this.dataComplianceInfoData?.qualificationMaterials || '';
                const hasQualificationMaterials = this.checkFileExists(qualificationMaterials);

                // 检查数据合规信息中的文件是否存在
                const dataSourceMaterials = this.dataComplianceInfoData?.dataSourceMaterials || '';
                const dataSampleMaterials = this.dataComplianceInfoData?.dataSampleMaterials || '';
                const dataStorageMaterials = this.dataComplianceInfoData?.dataStorageMaterials || '';

                const hasDataSourceMaterials = this.checkFileExists(dataSourceMaterials);
                const hasDataSampleMaterials = this.checkFileExists(dataSampleMaterials);
                const hasDataStorageMaterials = this.checkFileExists(dataStorageMaterials);

                // 所有必需文件都存在才算材料齐全
                const allMaterialsExist = hasQualificationMaterials &&
                    hasDataSourceMaterials &&
                    hasDataSampleMaterials &&
                    hasDataStorageMaterials;

                // 更新结果和状态
                materialItem.result = allMaterialsExist ? '1' : '0';
                materialItem.status = '检测完毕';
                materialItem.taskId = 'local-check-' + Date.now();

                // 显示检测结果
                if (allMaterialsExist) {
                    // this.$message.success('材料齐全，所有必需文件都存在');
                } else {
                    let missingFiles = [];
                    if (!hasQualificationMaterials) missingFiles.push('资质证明材料');
                    if (!hasDataSourceMaterials) missingFiles.push('数据来源文件');
                    if (!hasDataSampleMaterials) missingFiles.push('数据脱敏处理文件');
                    if (!hasDataStorageMaterials) missingFiles.push('数据存储安全文件');

                    this.$message.warning(`材料不齐全，缺少：${missingFiles.join('、')}`);
                }

            } catch (error) {
                console.error('材料检测失败:', error);
                this.$message.error('材料检测失败: ' + error.message);
                // 恢复状态
                const materialItem = this.complianceItems[0];
                materialItem.status = '未检测';
            }
        },

        // 修改：企业主体是否合规检测
        async handleEnterprise() {
            try {
                console.log('开始企业主体是否合规检测...');

                // 设置状态为检测中
                const enterpriseItem = this.complianceItems[1];
                enterpriseItem.status = '检测中';

                // 添加3-5秒的检测延迟
                await this.simulateDetectionDelay(3, 5);

                // 检查企业合规信息中的资质证明材料是否存在
                const qualificationMaterials = this.dataComplianceInfoData?.qualificationMaterials || '';
                const hasQualificationMaterials = this.checkFileExists(qualificationMaterials);

                // 更新结果和状态
                enterpriseItem.result = hasQualificationMaterials ? '1' : '0';
                enterpriseItem.status = '检测完毕';
                enterpriseItem.taskId = 'local-check-' + Date.now();

                // 显示检测结果
                if (hasQualificationMaterials) {
                    // this.$message.success('企业主体合规，资质证明材料存在');
                } else {
                    this.$message.warning('企业主体不合规，缺少资质证明材料');
                }

            } catch (error) {
                console.error('企业主体检测失败:', error);
                this.$message.error('企业主体检测失败: ' + error.message);
                // 恢复状态
                const enterpriseItem = this.complianceItems[1];
                enterpriseItem.status = '未检测';
            }
        },
        // 新增：检查文件是否存在的方法
        checkFileExists(fileValue) {
            if (!fileValue) return false;

            // 处理字符串或数组
            const fileList = this.getFileList(fileValue);
            return fileList.length > 0;
        },
        // 修改：查看详情方法
        toDetail(item) {
            console.log("查看详情:", item);

            if (!item.taskId || item.taskId === '') {
                this.$message.error('请先提交评估！');
                return;
            }

            console.log("TaskID:", item.taskId);

            // 如果是本地检测，显示检测结果
            if (item.taskId.startsWith('local-check-')) {
                let resultMessage = '';

                switch (item.type) {
                    case 'material':
                        resultMessage = item.result === '1'
                            ? '材料齐全，所有必需文件都存在'
                            : '材料不齐全，缺少必需文件';
                        break;
                    case 'enterprise':
                        resultMessage = item.result === '1'
                            ? '企业主体合规，资质证明材料存在'
                            : '企业主体不合规，缺少资质证明材料';
                        break;
                    default:
                        resultMessage = '检测已完成';
                }

                this.$alert(resultMessage, '检测结果', {
                    confirmButtonText: '确定',
                    type: item.result === '1' ? 'success' : 'warning'
                });
                return;
            }

            // 构建详情页URL
            let detailUrl;
            const aiFontBaseUrl = process.env.VUE_APP_AI_FONTEND_BASE_URL
            console.log("VUE_APP_AI_FONTEND_BASE_URL:", aiFontBaseUrl);
            switch (item.type) {
                case 'source': // 数据来源
                    detailUrl = `${aiFontBaseUrl}?view=detail&task_id=${item.taskId}`;
                    break;
                case 'storage': // 数据存储
                    detailUrl = `${aiFontBaseUrl}?view=compliance-detail&task_id=${item.taskId}`;
                    break;
                case 'desensitization': // 数据脱敏
                    detailUrl = `${aiFontBaseUrl}?view=datamask-detail&task_id=${item.taskId}`;
                    break;
                default:
                    detailUrl = `${aiFontBaseUrl}?view=detail&task_id=${item.taskId}`;
            }

            // 打开新页面
            window.open(detailUrl, '_blank');
        },
        async handleSource() {
            try {
                // 设置状态为评估中
                const sourceItem = this.complianceItems[2];
                sourceItem.status = '评估中';

                console.log('VUE_APP_AI_BACKEND_BASE_URL:', process.env.VUE_APP_AI_BACKEND_BASE_URL);

                const response = await fetch(this.aiBackBaseUrl + 'ai/compliance/dataSource', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        company_name: this.companyName,
                        registration_id: this.registrationId,
                        user_id: this.userId
                    })
                });

                const data = await response.json();

                if (data.task_id) {
                    console.log('处理响应数据:', data);

                    // 更新任务ID和状态
                    sourceItem.taskId = data.task_id;
                    sourceItem.status = '评估完毕';

                    // 设置AI任务ID
                    this.$set(this.aiTasks, 'sourceTaskID', data.task_id);

                    if (data.ownership_judgment && data.ownership_judgment.is_owner_match) {
                        // 根据is_owner_match的值设置单选按钮
                        if (data.ownership_judgment.is_owner_match.toLowerCase() === 'yes') {
                            sourceItem.result = '1'; // 是
                        } else if (data.ownership_judgment.is_owner_match.toLowerCase() === 'no') {
                            sourceItem.result = '0'; // 否
                        }
                    }

                    this.$message.success('数据来源评估完成');
                } else {
                    console.error('响应数据为空');
                    this.$message.error(data.message);
                    sourceItem.status = '未提交';
                }

            } catch (error) {
                console.error('API调用失败:', error);
                this.$message.error(`请求错误: ${error.message}`);
                // 恢复状态
                const sourceItem = this.complianceItems[2];
                sourceItem.status = '未提交';
            } finally {
                this.setLoadingState('source', false);
            }
        },


        async handleDesensitization() {
            console.log("开始数据脱敏核查任务：");
            try {
                // 设置状态为评估中
                const desensitizationItem = this.complianceItems[4];
                desensitizationItem.status = '评估中';

                const response = await fetch(this.aiBackBaseUrl + 'ai/datamask/dataSource', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        registration_id: this.registrationId,
                        user_id: this.userId
                    })
                });

                const data = await response.json();
                if (data.task_id) {
                    console.log('处理响应数据:', data);

                    // 更新任务ID和状态
                    desensitizationItem.taskId = data.task_id;
                    desensitizationItem.status = '评估完毕';

                    // 设置AI任务ID
                    this.$set(this.aiTasks, 'desensitizationTaskID', data.task_id);

                    if (data.datamask_judgment !== null) {
                        // 根据desensitized的值设置单选按钮
                        if (data.datamask_judgment.desensitized.toLowerCase() === 'yes') {
                            desensitizationItem.result = '1'; // 是
                        } else if (data.datamask_judgment.desensitized.toLowerCase() === 'no') {
                            desensitizationItem.result = '0'; // 否
                        }
                    }

                    this.$message.success('数据脱敏评估完成');
                } else {
                    console.error('响应数据为空');
                    this.$message.error(data.message);
                    desensitizationItem.status = '未提交';
                }

            } catch (error) {
                console.error('API调用失败:', error);
                this.$message.error(`请求错误: ${error.message}`);
                // 恢复状态
                const desensitizationItem = this.complianceItems[4];
                desensitizationItem.status = '未提交';
            } finally {
                this.setLoadingState('desensitization', false);
            }
        },

        // 修改：数据存储评估方法
        async handleStorage() {
            console.log("开始数据存储核查任务：");
            try {
                // 设置状态为评估中
                const storageItem = this.complianceItems[3];
                storageItem.status = '评估中';

                const response = await fetch(this.aiBackBaseUrl + 'ai/storageCompliance/dataSource', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        company_name: this.companyName,
                        registration_id: this.registrationId,
                        user_id: this.userId,
                        external_storage: this.isSelfStorage
                    })
                });

                const data = await response.json();

                if (data.task_id) {
                    console.log('处理响应数据:', data);

                    // 更新任务ID和状态
                    storageItem.taskId = data.task_id;
                    storageItem.status = '评估完毕';

                    // 设置AI任务ID
                    this.$set(this.aiTasks, 'storageTaskID', data.task_id);

                    if (data.storage_compliance_judgment !== null) {
                        // 根据compliant的值设置单选按钮
                        if (data.storage_compliance_judgment.compliant.toLowerCase() === 'yes') {
                            storageItem.result = '1'; // 是
                        } else if (data.storage_compliance_judgment.compliant.toLowerCase() === 'no') {
                            storageItem.result = '0'; // 否
                        }
                    }

                    this.$message.success('数据存储评估完成');
                } else {
                    console.error('响应数据为空');
                    this.$message.error(data.message);
                    storageItem.status = '未提交';
                }

            } catch (error) {
                console.error('API调用失败:', error);
                this.$message.error(`请求错误: ${error.message}`);
                // 恢复状态
                const storageItem = this.complianceItems[3];
                storageItem.status = '未提交';
            } finally {
                this.setLoadingState('storage', false);
            }
        },

        getFileUrls(type) {
            // let fileBaseUrl = '/www/lzw/work/tools/file/upload/'
            // let fileBaseUrl = '../DevelopFiles/file/upload/'
            let fileUrls = []

            console.log(this.fileBaseUrl);
            if (this.dataComplianceInfoData.dataSourceMaterials &&
                Array.isArray(this.dataComplianceInfoData.dataSourceMaterials)) {

                fileUrls = this.dataComplianceInfoData.dataSourceMaterials.map(fileName => {
                    return this.fileBaseUrl + this.userId + '/' +
                        this.registrationId + '/' + type + '/' + fileName
                })
            }

            return fileUrls
        },

        async handleSource1() {
            try {
                // 设置状态为评估中
                const sourceItem = this.complianceItems[2];
                sourceItem.status = '评估中';

                let fileUrl = this.getFileUrls('dataCompliance')
                console.log(fileUrl);
                console.log('VUE_APP_AI_BACKEND_BASE_URL:', process.env.VUE_APP_AI_BACKEND_BASE_URL);

                const documents = fileUrl.map(filePath => {
                    const fileName = filePath.split('/').pop(); // 从路径中提取文件名
                    return {
                        name: fileName,
                        source: filePath,
                        path: filePath,
                        type_hint: null
                    };
                });

                console.log("documents:", documents);
                const apiUrl = process.env.VUE_APP_AI_BACKEND_BASE_URL + 'api/tasks';
                const aiArgs = {
                    asset_id: this.AssetNameForAI,
                    registry_info: {},
                    company_name: this.companyName || '',
                    documents: documents
                }

                console.log('aiArgs:', aiArgs);
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(aiArgs)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                console.log('任务创建成功:', data);

                if (data.task_id) {
                    console.log('处理响应数据:', data);

                    // 更新任务ID和状态
                    sourceItem.taskId = data.task_id;
                    sourceItem.status = '评估中'; // 保持评估中状态，等待轮询结果

                    // 设置AI任务ID
                    this.$set(this.aiTasks, 'sourceTaskID', data.task_id);

                    // 开始轮询任务状态
                    this.pollSourceTaskStatus(data.task_id, sourceItem);

                } else {
                    console.error('响应数据中没有task_id');
                    this.$message.error(data.message || '任务创建失败');
                    sourceItem.status = '未提交';
                }

            } catch (error) {
                console.error('API调用失败:', error);
                this.$message.error(`请求错误: ${error.message}`);

                // 恢复状态
                const sourceItem = this.complianceItems[2];
                sourceItem.status = '未提交';
            } finally {
                // this.setLoadingState('source', false);
            }
        },

        // 新增轮询方法
        pollSourceTaskStatus(taskId, sourceItem) {
            const pollTaskStatus = async () => {
                const statusUrl = process.env.VUE_APP_AI_BACKEND_BASE_URL + `api/tasks/${taskId}`;

                try {
                    const statusResponse = await fetch(statusUrl);
                    if (!statusResponse.ok) {
                        throw new Error(`HTTP error! status: ${statusResponse.status}`);
                    }

                    const statusResult = await statusResponse.json();
                    console.log('任务状态:', statusResult);

                    // 根据任务状态进行处理
                    if (statusResult.status === 'completed') {
                        // 获取任务结果
                        const resultUrl = process.env.VUE_APP_AI_BACKEND_BASE_URL + `api/tasks/${taskId}/result`;
                        try {
                            const resultResponse = await fetch(resultUrl);
                            if (!resultResponse.ok) {
                                throw new Error(`HTTP error! status: ${resultResponse.status}`);
                            }

                            const taskResult = await resultResponse.json();
                            console.log('任务结果:', taskResult);

                            // 处理数据来源评估结果
                            if (taskResult.result) {
                                // 更新评估结果
                                sourceItem.status = '评估完毕';

                                // 处理所有权判断
                                if (taskResult.result.ownership &&
                                    taskResult.result.ownership.is_owner_match) {

                                    const isOwnerMatch = taskResult.result.ownership.is_owner_match.toLowerCase();
                                    if (isOwnerMatch === 'yes') {
                                        sourceItem.result = '1'; // 是
                                    } else {
                                        sourceItem.result = '0'; // 否
                                    }
                                    // else if (isOwnerMatch === 'no') {
                                    //     sourceItem.result = '0'; // 否
                                    // }
                                }

                                // 处理其他评估结果（如果有的话）
                                // 例如：sourceItem.aiEvaluation = taskResult.result.result.final_text;

                                this.$message.success('数据来源评估完成');
                            } else {
                                console.warn('任务结果格式不符合预期:', taskResult);
                                sourceItem.status = '评估完毕';
                                this.$message.success('数据来源评估完成');
                            }

                        } catch (resultError) {
                            console.error('获取任务结果失败:', resultError);
                            sourceItem.status = '评估完毕';
                            this.$message.error('获取评估结果失败: ' + resultError.message);
                        }

                        // 轮询完成后清除加载状态
                        this.setLoadingState('source', false);
                        return;

                    } else if (statusResult.status === 'failed') {
                        console.error('任务处理失败:', statusResult.error);
                        sourceItem.status = '未提交';
                        this.$message.error(`数据来源评估失败: ${statusResult.error || '未知错误'}`);
                        // 轮询完成后清除加载状态
                        this.setLoadingState('source', false);
                        return;

                    } else {
                        // 如果任务还在进行中，继续轮询
                        setTimeout(pollTaskStatus, 5000); // 5秒后再次轮询
                    }

                } catch (error) {
                    console.error('获取任务状态失败:', error);
                    sourceItem.status = '未提交';
                    this.$message.error('获取任务状态失败: ' + error.message);
                    // 轮询完成后清除加载状态
                    this.setLoadingState('source', false);
                }
            };

            // 开始轮询
            pollTaskStatus();
        },

        async handleDesensitization1() {
            try {
                // 设置状态为评估中
                const desensitizationItem = this.complianceItems[4];
                desensitizationItem.status = '评估中';

                // 获取数据脱敏处理文件的完整路径
                let fileUrl = this.getDesensitizationFileUrls();
                console.log('脱敏文件路径:', fileUrl);
                console.log('VUE_APP_AI_BACKEND_BASE_URL:', process.env.VUE_APP_AI_BACKEND_BASE_URL);

                const documents = fileUrl.map(filePath => {
                    const fileName = filePath.split('/').pop(); // 从路径中提取文件名
                    return {
                        name: fileName,
                        source: filePath,
                        path: filePath,
                        type_hint: null
                    };
                });

                console.log("脱敏文档列表:", documents);
                const apiUrl = process.env.VUE_APP_AI_BACKEND_BASE_URL + 'api/datamask_tasks';
                const aiArgs = {
                    asset_id: this.AssetNameForAI,
                    registry_info: {},
                    company_name: this.companyName || '',
                    documents: documents
                }

                console.log('脱敏评估参数:', aiArgs);
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(aiArgs)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                console.log('脱敏评估任务创建成功:', data);

                if (data.task_id) {
                    console.log('处理脱敏评估响应数据:', data);

                    // 更新任务ID和状态
                    desensitizationItem.taskId = data.task_id;
                    desensitizationItem.status = '评估中'; // 保持评估中状态，等待轮询结果

                    // 设置AI任务ID
                    this.$set(this.aiTasks, 'desensitizationTaskID', data.task_id);

                    // 开始轮询任务状态
                    this.pollDesensitizationTaskStatus(data.task_id, desensitizationItem);

                } else {
                    console.error('响应数据中没有task_id');
                    this.$message.error(data.message || '脱敏评估任务创建失败');
                    desensitizationItem.status = '未提交';
                }

            } catch (error) {
                console.error('脱敏评估API调用失败:', error);
                this.$message.error(`请求错误: ${error.message}`);

                // 恢复状态
                const desensitizationItem = this.complianceItems[4];
                desensitizationItem.status = '未提交';
            } finally {
                // this.setLoadingState('desensitization', false);
            }
        },

        // 获取数据脱敏处理文件的完整路径
        getDesensitizationFileUrls() {
            // let fileBaseUrl = '/www/lzw/work/tools/file/upload/'
            // let fileBaseUrl = '../DevelopFiles/file/upload/'
            let fileUrls = []

            if (this.dataComplianceInfoData.dataSampleMaterials &&
                Array.isArray(this.dataComplianceInfoData.dataSampleMaterials)) {

                fileUrls = this.dataComplianceInfoData.dataSampleMaterials.map(fileName => {
                    return this.fileBaseUrl + this.userId + '/' +
                        this.registrationId + '/dataCompliance/' + fileName
                })
            }

            return fileUrls
        },

        // 数据脱敏评估轮询方法
        pollDesensitizationTaskStatus(taskId, desensitizationItem) {
            const pollTaskStatus = async () => {
                const statusUrl = process.env.VUE_APP_AI_BACKEND_BASE_URL + `api/tasks/${taskId}`;

                try {
                    const statusResponse = await fetch(statusUrl);
                    if (!statusResponse.ok) {
                        throw new Error(`HTTP error! status: ${statusResponse.status}`);
                    }

                    const statusResult = await statusResponse.json();
                    console.log('脱敏评估任务状态:', statusResult);

                    // 根据任务状态进行处理
                    if (statusResult.status === 'completed') {
                        // 获取任务结果
                        const resultUrl = process.env.VUE_APP_AI_BACKEND_BASE_URL + `api/tasks/${taskId}/result`;
                        try {
                            const resultResponse = await fetch(resultUrl);
                            if (!resultResponse.ok) {
                                throw new Error(`HTTP error! status: ${resultResponse.status}`);
                            }

                            const taskResult = await resultResponse.json();
                            console.log('脱敏评估任务结果:', taskResult);

                            // 处理数据脱敏评估结果
                            if (taskResult.result && taskResult.result.result) {
                                // 更新评估结果
                                desensitizationItem.status = '评估完毕';

                                // 处理脱敏判断
                                if (taskResult.result.result.desensitized) {

                                    const isDesensitized = taskResult.result.result.desensitized.toLowerCase();
                                    if (isDesensitized === 'yes') {
                                        desensitizationItem.result = '1'; // 是
                                    } else if (isDesensitized === 'no') {
                                        desensitizationItem.result = '0'; // 否
                                    }
                                }

                                this.$message.success('数据脱敏评估完成');
                            } else {
                                console.warn('脱敏评估任务结果格式不符合预期:', taskResult);
                                desensitizationItem.status = '评估完毕';
                                this.$message.success('数据脱敏评估完成');
                            }

                        } catch (resultError) {
                            console.error('获取脱敏评估结果失败:', resultError);
                            desensitizationItem.status = '评估完毕';
                            this.$message.error('获取脱敏评估结果失败: ' + resultError.message);
                        }



                        // 轮询完成后清除加载状态
                        this.setLoadingState('desensitization', false);
                        return;

                    } else if (statusResult.status === 'failed') {
                        console.error('脱敏评估任务处理失败:', statusResult.error);
                        desensitizationItem.status = '未提交';
                        this.$message.error(`数据脱敏评估失败: ${statusResult.error || '未知错误'}`);
                        // 轮询完成后清除加载状态
                        this.setLoadingState('desensitization', false);
                        return;

                    } else {
                        // 如果任务还在进行中，继续轮询
                        setTimeout(pollTaskStatus, 5000); // 5秒后再次轮询
                    }

                } catch (error) {
                    console.error('获取脱敏评估任务状态失败:', error);
                    desensitizationItem.status = '未提交';
                    this.$message.error('获取脱敏评估任务状态失败: ' + error.message);
                    // 轮询完成后清除加载状态
                    this.setLoadingState('desensitization', false);
                }
            };

            // 开始轮询
            pollTaskStatus();
        },

        async handleStorage1() {
            try {
                // 设置状态为评估中
                const storageItem = this.complianceItems[3];
                storageItem.status = '评估中';

                // 获取数据存储安全文件的完整路径
                let fileUrl = this.getStorageFileUrls();
                console.log('存储文件路径:', fileUrl);
                console.log('VUE_APP_AI_BACKEND_BASE_URL:', process.env.VUE_APP_AI_BACKEND_BASE_URL);

                const documents = fileUrl.map(filePath => {
                    const fileName = filePath.split('/').pop(); // 从路径中提取文件名
                    return {
                        name: fileName,
                        source: filePath,
                        path: filePath,
                        type_hint: null
                    };
                });

                console.log("存储文档列表:", documents);
                const apiUrl = process.env.VUE_APP_AI_BACKEND_BASE_URL + 'api/compliance_tasks';
                const aiArgs = {
                    asset_id: this.AssetNameForAI,
                    registry_info: {},
                    company_name: this.companyName || '',
                    documents: documents,
                    external_storage: this.isSelfStorage // 保留外部存储参数
                }

                console.log('存储评估参数:', aiArgs);
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(aiArgs)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                console.log('存储评估任务创建成功:', data);

                if (data.task_id) {
                    console.log('处理存储评估响应数据:', data);

                    // 更新任务ID和状态
                    storageItem.taskId = data.task_id;
                    storageItem.status = '评估中'; // 保持评估中状态，等待轮询结果

                    // 设置AI任务ID
                    this.$set(this.aiTasks, 'storageTaskID', data.task_id);

                    // 开始轮询任务状态
                    this.pollStorageTaskStatus(data.task_id, storageItem);

                } else {
                    console.error('响应数据中没有task_id');
                    this.$message.error(data.message || '存储评估任务创建失败');
                    storageItem.status = '未提交';
                }

            } catch (error) {
                console.error('存储评估API调用失败:', error);
                this.$message.error(`请求错误: ${error.message}`);

                // 恢复状态
                const storageItem = this.complianceItems[3];
                storageItem.status = '未提交';
            } finally {
                // this.setLoadingState('storage', false);
            }
        },

        // 获取数据存储安全文件的完整路径
        getStorageFileUrls() {
            // let fileBaseUrl = '/www/lzw/work/tools/file/upload/'
            // let fileBaseUrl = '../DevelopFiles/file/upload/'
            let fileUrls = []

            if (this.dataComplianceInfoData.dataStorageMaterials &&
                Array.isArray(this.dataComplianceInfoData.dataStorageMaterials)) {

                fileUrls = this.dataComplianceInfoData.dataStorageMaterials.map(fileName => {
                    return this.fileBaseUrl + this.userId + '/' +
                        this.registrationId + '/dataCompliance/' + fileName
                })
            }

            return fileUrls
        },

        // 数据存储评估轮询方法
        pollStorageTaskStatus(taskId, storageItem) {
            const pollTaskStatus = async () => {
                const statusUrl = process.env.VUE_APP_AI_BACKEND_BASE_URL + `api/tasks/${taskId}`;

                try {
                    const statusResponse = await fetch(statusUrl);
                    if (!statusResponse.ok) {
                        throw new Error(`HTTP error! status: ${statusResponse.status}`);
                    }

                    const statusResult = await statusResponse.json();
                    console.log('存储评估任务状态:', statusResult);

                    // 根据任务状态进行处理
                    if (statusResult.status === 'completed') {
                        // 获取任务结果
                        const resultUrl = process.env.VUE_APP_AI_BACKEND_BASE_URL + `api/tasks/${taskId}/result`;
                        try {
                            const resultResponse = await fetch(resultUrl);
                            if (!resultResponse.ok) {
                                throw new Error(`HTTP error! status: ${resultResponse.status}`);
                            }

                            const taskResult = await resultResponse.json();
                            console.log('存储评估任务结果:', taskResult);

                            // 处理数据存储评估结果
                            if (taskResult.result && taskResult.result.result) {
                                // 更新评估结果
                                storageItem.status = '评估完毕';

                                // 处理存储合规判断
                                if (taskResult.result.result.compliant) {

                                    const isCompliant = taskResult.result.result.compliant.toLowerCase();
                                    if (isCompliant === 'yes') {
                                        storageItem.result = '1'; // 是
                                    } else if (isCompliant === 'no') {
                                        storageItem.result = '0'; // 否
                                    }
                                }

                                this.$message.success('数据存储评估完成');
                            } else {
                                console.warn('存储评估任务结果格式不符合预期:', taskResult);
                                storageItem.status = '评估完毕';
                                this.$message.success('数据存储评估完成');
                            }

                        } catch (resultError) {
                            console.error('获取存储评估结果失败:', resultError);
                            storageItem.status = '评估完毕';
                            this.$message.error('获取存储评估结果失败: ' + resultError.message);
                        }
                        // 轮询完成后清除加载状态
                        this.setLoadingState('storage', false);
                        return;

                    } else if (statusResult.status === 'failed') {
                        console.error('存储评估任务处理失败:', statusResult.error);
                        storageItem.status = '未提交';
                        this.$message.error(`数据存储评估失败: ${statusResult.error || '未知错误'}`);
                        // 轮询完成后清除加载状态
                        this.setLoadingState('storage', false);
                        return;

                    } else {
                        // 如果任务还在进行中，继续轮询
                        setTimeout(pollTaskStatus, 5000); // 5秒后再次轮询
                    }

                } catch (error) {
                    console.error('获取存储评估任务状态失败:', error);
                    storageItem.status = '未提交';
                    this.$message.error('获取存储评估任务状态失败: ' + error.message);

                    // 轮询完成后清除加载状态
                    this.setLoadingState('storage', false);
                }
            };

            // 开始轮询
            pollTaskStatus();
        },


        // 判断是否显示undetermined提示
        showUndeterminedPrompt(taskKey) {
            const result = this.aiTaskResults[taskKey];
            return result === 'undetermined' && this.aiTasks[taskKey];
        },


        // 法律意见书
        async systmReport() {


            // 构建 CompanySubmit 对象
            const companySubmit = {
                registrationId: this.registrationId,
                qualificationMaterials: this.getFileList(this.dataComplianceInfoData?.qualificationMaterials || ''),
                dataSourceMaterials: this.getFileList(this.dataComplianceInfoData?.dataSourceMaterials || ''),
                dataSampleMaterials: this.getFileList(this.dataComplianceInfoData?.dataSampleMaterials || ''),
                dataStorageMaterials: this.getFileList(this.dataComplianceInfoData?.dataStorageMaterials || '')
            };
            try {

                const response = await this.$axios.post('/web/dataCompliance/createComplianceReport', companySubmit, {

                });
                // console.log("response");
                if (response.data.status == 200) {

                    // console.log(response.data.object);
                    this.sysReportName = response.data.object;
                }


            } catch (error) {
                console.error('请求出错:', error);
                if (error.response) {
                    console.error('错误详情:', error.response.status, error.response.data);
                }
            }
        },

        // AI生成报告
        aiReport() {
            this.$message.success('AI报告已生成！');
        },

        // 获取文件列表（处理字符串或数组）
        getFileList(fileValue) {
            if (!fileValue) return [];

            if (Array.isArray(fileValue)) {
                return fileValue;
            }

            if (typeof fileValue === 'string') {
                // 如果是逗号分隔的文件名，分割成数组
                return fileValue.split(',').map(item => item.trim()).filter(item => item);
            }

            return [fileValue];
        },
        // 判断文件是否可以预览
        isPreviewable(fileName) {
            if (!fileName) return false;

            // 确保fileName是字符串
            const fileNameStr = String(fileName).trim();
            if (!fileNameStr) return false;

            const ext = this.getFileExtension(fileNameStr);
            const previewableTypes = [
                'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', // 图片
                'pdf', // PDF
                'xls', 'xlsx', 'csv', // Excel文件
                'doc', 'docx', // Word文档
                'txt', 'json', 'xml', 'csv', 'log', 'js', 'css', 'html', 'md' // 文本文件
            ];
            return previewableTypes.includes(ext);
        },
        // 获取文件扩展名
        getFileExtension(filename) {
            if (!filename) return '';
            const parts = String(filename).split('.');
            return parts.length > 1 ? parts.pop().toLowerCase() : '';
        },
        // 预览文件
        async previewFile(fileName) {
            const fileNameStr = String(fileName).trim();
            if (!fileNameStr) {
                this.$message.warning('文件名不能为空');
                return;
            }

            this.isPreviewLoading = true;
            try {
                await this.$refs.filePreview.openPreview(
                    { fileName: fileNameStr },
                    this.registrationId
                );
            } catch (error) {
                console.error('预览失败:', error);
                this.$message.error('文件预览失败: ' + (error.message || ''));
            } finally {
                this.isPreviewLoading = false;
            }
        },


        // 关闭
        close(targetPage = '/home') {
            const fullPath = this.$route.fullPath;
            const currentPath = this.$route.path;

            // 1. 先跳转到指定页面
            if (currentPath !== targetPage) {
                this.$router.push(targetPage).then(() => {
                    // 2. 跳转成功后延迟关闭当前标签页
                    setTimeout(() => {
                        this.closeTab(fullPath);
                    }, 100);
                }).catch(() => {
                    // 跳转失败时仍然尝试关闭
                    this.closeTab(fullPath);
                });
            } else {
                // 如果已经在目标页面，直接关闭
                this.closeTab(fullPath);
            }
        },

        // 提取关闭标签页的公共方法
        closeTab(fullPath) {
            this.$emit('close-tab', fullPath);

            let parent = this.$parent;
            while (parent) {
                if (typeof parent.removeTab === 'function') {
                    parent.removeTab(fullPath);
                    break;
                }
                parent = parent.$parent;
            }
        },


        // 查看企业详情
        viewCompanyDetail() {
            if (this.userId) {
                this.$router.push(`/index/company/companyInfoView?companyId=${this.companyId}`);
            } else {
                this.$message.warning('无法获取企业ID信息');
            }
        },

        // 查看数据资产详情
        viewReviewManage() {
            if (this.registrationId) {
                this.$router.push(`/index/company/review-manage?registrationId=${this.registrationId}`);
            } else {
                this.$message.warning('无法获取登记ID信息');
            }
        }
    },
    computed: {

        isSubmitDisabled() {
            // 检查合规审核项目是否都已选择
            const complianceItemsCompleted = this.complianceItems.every(item =>
                item.result === '1' || item.result === '0'
            );

            // 检查报告文件是否已上传
            const hasReportFile = this.reportFile && this.reportFile.length > 0;

            // 
            const hasComments = this.platformReviewComments != '';

            // 必须同时满足两个条件才能提交
            return !(complianceItemsCompleted && hasReportFile && hasComments);
        }
    }
}
</script>

<style scoped>
.data-evaluation-page {
    padding: 15px;
    background-color: #f5f5f5;
}

.box-card {
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.box-card>>>.el-card__header {
    background-color: #f0f0f0;
    font-weight: bold;
    font-size: 16px;
    color: #333;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}

.el-form-item {
    margin-bottom: 10px;
}

.el-form-item>>>.el-form-item__label {
    color: #666;
    font-weight: normal;
}

.report-name-container {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
}

.report-name-container .el-tag {
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 12px;
    color: #333;
    background-color: #f0f9ff;
    border: 1px solid #d9ecff;
}



.undetermined-prompt {
    color: #f56c6c;
    font-size: 12px;
    /* white-space: nowrap; */
    display: inline;
    /* margin-left: 8px; */
    /* vertical-align: middle; */

}
</style>